export const usePermissions = (moduleName) => {
  const storedUser = localStorage.getItem("userDetails");
  const parsedUser = storedUser ? JSON.parse(storedUser) : null;

  const permissions = parsedUser?.permissions || {
    "Priority Outreach": { read: 0, write: 0, edit: 0, delete: 0 },
  };
  const modulePermissions = permissions[moduleName] || {
    read: 0,
    write: 0,
    edit: 0,
    delete: 0,
  };

  return {
    canRead: modulePermissions.read === 1,
    canWrite: modulePermissions.write === 1,
    canEdit: modulePermissions.edit === 1,
    canDelete: modulePermissions.delete === 1,
  };
};
